@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (ListLinks && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Link Manager
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      This screen allows venues to create customizable booking links for their packages. They can add package groups, individual packages, and specific dates to the link. Once generated, venues can copy the link ID and append it to a URL with the correct query string format, making it easy for customers to book directly through the link.
    </p>
    <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
      <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'height': '50px'}" (click)="toggleDisabled()">
      </p-togglebutton>
      <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="linkTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Link Name"/>
      </span>
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/linkeditor/0']" i18>
        <span class="pi pi-plus" style="margin-right:8px;"></span>
        <span i18>Add</span>
      </button>
      &nbsp;
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span i18>Disable</span>
      </button>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table #linkTable
        [columns]="cols"
        [value]="ListLinks.data" sortField="linkname" [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true" responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        [globalFilterFields]="['linkname']"
        [(selection)]="selectedItems"
        responsiveLayout="scroll"
        datakey="linkid"
        [selectionPageOnly]="true">
        <ng-template #caption>
          <div class="flex">
            <button
              type="button"
              pButton
              pRipple
              (click)="linkTable.exportCSV()"
              class="mr-2"
              pTooltip="Export to CSV"
              tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
            </div>
          </ng-template>
          <ng-template #header>
            <tr>
              <th>
                <p-tableheadercheckbox></p-tableheadercheckbox>
              </th>
              <th pSortableColumn="linkname" width="30%">Name
                <p-sorticon [field]="linkname"></p-sorticon>
              </th>
              <th width="35%">Link ID</th>
              <th width="19%">Link Type</th>
              <th width="2%"></th>
              <th width="2%"></th>
              <th width="2%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-data>
            <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
              <td>
                <p-tablecheckbox [value]="data"></p-tablecheckbox>
              </td>
              <td>{{data.linkname}}</td>
              <td>LinkId={{data.linkid}}</td>
              <td>{{data.linktype}}</td>
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="margin-right: -20px;" (click)="editData(data.linkid);" i18>
                <span class="pi pi-pencil" style="margin-right:8px;"></span>
                <span i18n>Edit</span>
              </button></td>
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="width:184px" (click)="copyData(data.linkstring);" i18>
                <span class="pi pi-copy" style="margin-right:8px;"></span>
                <span i18n>Copy to clipboard</span>
              </button></td>
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableData(data.linkid)" i18>
                <span class="pi pi-trash" style="margin-right:8px;"></span>
                <span i18n>Disable</span>
              </button></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
